import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-not-found",
  templateUrl: "./not-found.component.html",
  styleUrls: ["./not-found.component.scss"],
})
export class NotFoundComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {
    const url = this.router.url;
    console.log("[NotFoundComponent] URL:", url);

    // If running inside the native shell (Capacitor, non-web), do not
    // leave the user stranded on the 404. Instead, fail-safe back to /home.
    const w = window as any;
    const platform = w.Capacitor?.getPlatform
      ? w.Capacitor.getPlatform()
      : "web";

    if (platform !== "web") {
      this.router.navigateByUrl("/home");
    }
  }
}
